export function getTextFromElement(c: any, valCls?: string) {
    return getValue(c, valCls);
}

function getValue(c: any, valCls?: string): any {
    let val;
    // console.log(c, c.props, c instanceof Array);
    // alert('C');
    if (c && typeof c === 'object' && c.props) {
        if (c.props.className === (typeof valCls === 'string' ? valCls : 'value_export') &&
            (typeof c.props.children === 'string' || typeof c.props.children === 'number')) {
            val = c.props.children;
        } else if (c.props.children) {
            if (Array.isArray(c.props.children)) {
                c.props.children.some((r: any) => val = getValue(r));
            } else {
                val = getValue(c.props.children);
            }
        }
    } else {
        if (Array.isArray(c)) {
            return c.join(', ');
        }
    }
    return val;
}
